export const clamp = (value: number, min = 0, max = 1): number => Math.min(max, Math.max(min, value))

export const lerp = (from: number, to: number, amount: number): number => from + (to - from) * amount

/** Maps value from the [start, end] range onto 0..1, clamped. */
export const progressBetween = (value: number, start: number, end: number): number => {
    if (end === start) return value >= end ? 1 : 0
    return clamp((value - start) / (end - start))
}

export const easeInCubic = (t: number): number => t * t * t

export const easeOutCubic = (t: number): number => 1 - Math.pow(1 - t, 3)

export const easeInOutCubic = (t: number): number => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2)

export const smoothstep = (t: number): number => t * t * (3 - 2 * t)

/** How far a tall scroll track has been scrolled through while its sticky child is pinned (0..1). */
export const stickyProgress = (rect: DOMRect, viewportHeight: number): number => {
    const range = rect.height - viewportHeight
    if (range <= 1) return rect.top < 0 ? 1 : 0
    return clamp(-rect.top / range)
}

/** Only call from effects or event handlers: reads a browser API. */
export const prefersReducedMotion = (): boolean => {
    if (typeof window === 'undefined' || !window.matchMedia) return false
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}
